import { render, staticRenderFns } from "./table.vue?vue&type=template&id=0f8e45d0"
import script from "./table.vue?vue&type=script&lang=js"
export * from "./table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f8e45d0')) {
      api.createRecord('0f8e45d0', component.options)
    } else {
      api.reload('0f8e45d0', component.options)
    }
    module.hot.accept("./table.vue?vue&type=template&id=0f8e45d0", function () {
      api.rerender('0f8e45d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/contact/table.vue"
export default component.exports